import { createContext } from 'react'

type AlertState = {
  smallText?: boolean
}

export const AlertContext = createContext<AlertState>({})
